import React from "react";
import Home from "./component/Home";
import Instructions from "./component/Instructions";
import Documment from "./component/Documment";
import Integration from "./component/Integration";
import HandleRequest from "./component/HandleRequest";
import FeatureRequests from "./component/FeatureRequests";
import Welcome from "./component/Welcome";
import Orders from "./component/Orders";
import Account from "./component/Account";
import config from "./config/config";
import Settings from "./component/Settings";
import Dispute from "./component/Dispute";
import VideoTutorial from "./component/HelpCenter/VideoTutorial";
import WhatNew from "./component/whatnew/WhatNew";
import AffiliateProgram from "./component/feature/affiliate";

const routes = [
  {
    path: config.pathName + "/instructions",
    exact: false,
    main: () => <Instructions />,
  },
  {
    path: config.pathName + "/home",
    exact: false,
    main: () => <Home />,
  },
  {
    path: config.pathName + "/",
    exact: true,
    main: () => <Home />,
  },
  {
    path: config.pathName + "/orders",
    exact: false,
    main: () => <Orders />,
  },
  {
    path: config.pathName + "/settings",
    exact: false,
    main: () => <Settings />,
  },
  {
    path: config.pathName + "/integrations",
    exact: false,
    main: () => <Integration />,
  },
  {
    path: config.pathName + "/handle_request",
    exact: false,
    main: () => <HandleRequest />,
  },
  {
    path: config.pathName + "/welcome",
    exact: false,
    main: () => <Welcome />,
  },
  {
    path: config.pathName + "/feature-requests",
    exact: false,
    main: () => <FeatureRequests />,
  },
  {
    path: config.pathName + "/account",
    exact: false,
    main: () => <Account />,
  },
  {
    path: config.pathName + "/dispute",
    exact: false,
    main: () => <Dispute />,
  },
  {
    path: config.pathName + "/video-tutorial",
    exact: false,
    main: () => <VideoTutorial />,
  },
  {
    path: config.pathName + "/whatnew",
    exact: false,
    main: () => <WhatNew />
  },
  {
    path: config.pathName + "/affiliate",
    exact: false,
    main: () => <AffiliateProgram />
  },
];

export default routes;
